<template>
    <div class="d-flex flex-column">
        <div class="d-flex">
            <Slider
                lazy
                :min="min"
                :max="max"
                :width="600"
                :interval="0.1"
                v-model="model"
                :disabled="disabled"
                :tooltip="sliderTooltip"
                :tooltipFormatter="numberFormatter"
            />
            <small v-if="model" class="ml-2">{{ formattedModel }}</small>
        </div>
        <b-form-checkbox
            v-if="isNullable"
            :disabled="disabled"
            :checked="notAbleToAnswerIsChecked"
            @input="onClickNotAbleToAnswer"
        >
            {{ $t('form.button.notAbleToAnswer') }}
        </b-form-checkbox>
    </div>
</template>
<script>
import Slider from 'vue-slider-component'
import { formatNumber } from '@/lib/utils'
import { minBy, maxBy, orderBy } from 'lodash'
export default {
    components: {
        Slider,
    },
    props: {
        degrees: Array,
        hasScore: Boolean,
        disabled: Boolean,
        isNullable: Boolean,
        score: Number | String,
    },
    data() {
        return {
            lastScore: null,
        }
    },
    mounted() {
        this.lastScore = this.score
    },
    computed: {
        model: {
            set(value) {
                let degree = null
                if (value !== null) {
                    this.lastScore = value
                    degree = this.getScoreDegree(value)
                }

                this.$emit('change', value, degree)
            },
            get() {
                return this.score
            },
        },
        formattedModel() {
            const value = this.numberFormatter(this.score, 1)
            return value == false ? '-' : value
        },
        min() {
            return minBy(this.degrees, 'max_score').max_score
        },
        max() {
            return maxBy(this.degrees, 'max_score').max_score
        },
        notAbleToAnswerIsChecked() {
            return this.model == null && this.hasScore
        },
        orderedDegrees() {
            return orderBy(this.degrees, 'max_score', 'asc')
        },
        sliderTooltip() {
            return this.model == null ? 'none' : 'active'
        },
    },
    methods: {
        getScoreDegree(score) {
            const degree = this.orderedDegrees.find(degree => {
                return this.scoreIsInDegreeRange(degree, score)
            })

            return degree.id
        },
        scoreIsInDegreeRange(degree, score) {
            const degreesCount = this.orderedDegrees.length
            const index = this.orderedDegrees.indexOf(degree)

            if (index + 1 == degreesCount) {
                return true
            }

            const scoreIsEqualOrBiggerThanDegreeScore =
                score >= degree.max_score
            const nextDegree = this.orderedDegrees[index + 1]
            const scoreIsSmallThanNextDegreeScore = score < nextDegree.max_score

            if (
                scoreIsEqualOrBiggerThanDegreeScore &&
                scoreIsSmallThanNextDegreeScore
            ) {
                return true
            }

            return false
        },
        numberFormatter(value) {
            return formatNumber(value, 1)
        },
        onClickNotAbleToAnswer(isChecked) {
            if (isChecked) {
                this.model = null
            } else {
                this.model = this.lastScore
            }
        },
    },
}
</script>
<style lang="scss" scoped>
@import '~vue-slider-component/theme/default.css';
::v-deep .vue-slider {
    cursor: pointer;
}

::v-deep .vue-slider-disabled {
    opacity: 1;
    cursor: default;
}

::v-deep .vue-slider-dot-handle-disabled {
    cursor: default;
    background-color: #fff;
}

::v-deep .custom-control-input:disabled {
    color: none;
}

::v-deep
    .custom-checkbox
    .custom-control-input:disabled:checked
    ~ .custom-control-label::before {
    background-color: #009bdb;
}
</style>
